"use client"
import { Activity, ClipboardList } from "lucide-react";
import { formatDate } from "./utils";

export default function ReportHeader({ reportMetadata }) {
    if (!reportMetadata) return null;

    return (
        <div className="mb-6 sm:mb-8">
            <div className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Activity className="w-6 h-6 sm:w-7 sm:h-7 text-[#0B7BC1]" />
                </div>
                <div className="min-w-0 flex-1">
                    <h1 className="text-xl sm:text-2xl md:text-3xl font-semibold text-gray-900 break-words">
                        {reportMetadata.report_title || 'Clinical Decision Analysis'}
                    </h1>
                    {reportMetadata.generated_at && (
                        <p className="text-xs sm:text-sm text-gray-500 mt-1">
                            {formatDate(reportMetadata.generated_at)}
                        </p>
                    )}
                </div>
            </div>
            <div className="h-1 bg-gradient-to-r from-[#0B7BC1] to-[#1B8ED1] rounded-full w-20 sm:w-24 mb-4 sm:mb-5"></div>
            {reportMetadata.case_summary && (
                <div className="p-3 sm:p-4 md:p-5 lg:p-6 bg-blue-50 border border-blue-200 rounded-lg">
                    <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-2 flex items-center gap-2">
                        <ClipboardList className="w-4 h-4 sm:w-5 sm:h-5 text-[#0B7BC1] flex-shrink-0" />
                        Case Summary
                    </h3>
                    <p className="text-sm sm:text-base text-gray-700 leading-relaxed">{reportMetadata.case_summary}</p>
                </div>
            )}
        </div>
    );
}
